<template>
  <div>
    <div class="loading" v-if="loading">
      <md-progress-spinner class="md-accent" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div class="loading" v-if="!loading && errorMessage !== null">
      {{errorMessage}}
    </div>
    <div class="loading" v-if="!loading && errorMessage === null">

      <md-card>
        <md-card-header>
          <div class="md-title">Global Courses</div>
        </md-card-header>

        <md-card-content>
          <md-table>

            <md-table-row v-if="courses && courses.length > 0">
              <md-table-head md-sort-name="name">Name</md-table-head>
              <md-table-head>Activities</md-table-head>
            </md-table-row>

            <md-table-row v-for="object in courses" :key="object.versionedId.id" >
              <md-table-cell>{{object.name}}</md-table-cell>

              <md-table-cell>{{object.activities.length}}</md-table-cell>

              <md-table-cell>
                <md-button class="md-icon-button md-dense md-primary editButton" :to="'course/' + object.versionedId.id" >
                  <md-icon class="md-morph-final">edit</md-icon>
                </md-button>
                <span>
                  <md-icon style="margin-top: 4px;" v-if="!object.edit && isSoftLocked(object.versionedId.id)" class="md-morph-final"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                </span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-primary md-raised" @click="showNewObjectDialog">New Course</md-button>
        </md-card-actions>
      </md-card>

    </div>

    <md-dialog :md-active.sync="createPromptActive">
      <md-dialog-title>Create a new course</md-dialog-title>

      <div class="dialogContent">
        <md-field >
          <label>Name</label>
          <md-input v-focus ref="newObjectFirstField" v-model="newObject.name" @keyup.enter="createObject" @keyup.esc="createPromptActive = false"></md-input>
        </md-field>

        <md-dialog-actions>
          <md-button class="md-primary" @click="createPromptActive = false">Cancel</md-button>
          <md-button class="md-primary md-raised" @click="createObject" v-bind:disabled="!dialogCreateActive">Create</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

  </div>
</template>

<script>
  var nameCompareIgnoreCase = function(a, b) {
    var nameA = a.name.toUpperCase(); // ignore upper and lowercase
    var nameB = b.name.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // names must be equal
    return 0;
  };

  export default {
    name: "Courses",
    data() {
      var mutableFields = ['name'];
      var newObject = {};
      mutableFields.forEach(fieldName => {
        newObject[fieldName] = '';
      });
      return {
        loading: false,
        errorMessage: null,
        createPromptActive: false,
        newObject: newObject,
        mutableFields: mutableFields,
        coursesSubscriptionId: null,
        courses: []
      }
    },
    computed: {
      dialogCreateActive() {
        var active = true;
        this.mutableFields.forEach(fieldName => {
          if (this.newObject[fieldName].length < 1) {
            active = false;
          }
        });
        return active;
      }
    },
    methods: {
      isSoftLocked(lockId) {
        return (this.$store.state.otherUserPageLocks[lockId] !== undefined)
      },
      getLockedByString(lockId) {
        if (this.$store.state.otherUserPageLocks[lockId] !== undefined) {
          return Object.keys(this.$store.state.otherUserPageLocks[lockId]).join(', ');
        } else {
          return "";
        }
      },
      showNewObjectDialog() {
        this.mutableFields.forEach(fieldName => {
          this.newObject[fieldName] = '';
        });
        this.createPromptActive = true;
        var refs = this.$refs; setTimeout(() => this.$nextTick(() => refs.newObjectFirstField.$el.focus()), 300);
      },
      createObject() {
        this.createPromptActive = false;
        this.$store.api.rpcRequest('createCourse', {
          name: this.newObject.name,
          cityId: 'GLOBAL'
        }, newObject => {
        }, errorMessage => {
        });
      },
      globalDetailsHandler(newGlobalDetails) {
        newGlobalDetails.courses.sort(nameCompareIgnoreCase);
        this.courses = newGlobalDetails.courses;
      }
    },
    created() {
      this.coursesSubscriptionId = this.$store.api.subscribe("GLOBAL_DETAILS", null, this.globalDetailsHandler);
    },
    beforeDestroy() {
      if (this.coursesSubscriptionId) {
        this.$store.api.unsubscribe(this.coursesSubscriptionId);
      }
      this.coursesSubscriptionId = null;
    }
  }
</script>

<style scoped>
  .dialogContent {
    padding: 24px;
  }

  .md-table-head {
    text-align: center;
  }

  button.editButton { visibility: hidden;}
  tr:hover button.editButton{ visibility: visible;}

</style>



// WEBPACK FOOTER //
// src/components/admin/GlobalCourses.vue